import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const ZipCodeField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ zip: event.target.value }));
    };

    return (
        <TextField
            label="ZIP Code"
            value={currentRefund?.checkInfo?.zip || ''}
            onChange={handleChange}
            size="small"
            sx={{ flex: 1 }}
        />
    );
};

export default ZipCodeField;
